import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import React from 'react';
import { IApiSearchContent } from '~/searchApi/content';

export interface MetricItem {
  icon: React.ReactNode;
  label: string;
  value: string;
}
export const getMetricIcon = (metricKey: string) => {
  const iconMap: Record<string, React.ReactNode> = {
    engagements: <Icon name="Click" className="text-16 text-neutral-300" />,
    likes: <Icon name="ThumbUp" className="text-16 text-neutral-300" />,
    comments: <Icon name="Chat" className="text-16 text-neutral-300" />,
    saved: <Icon name="Save" className="text-16 text-neutral-300" />,
    shares: <Icon name="Share" className="text-16 text-neutral-300" />,
    reach: <Icon name="Reach" className="text-16 text-neutral-300" />,
    views: <Icon name="Eye" className="text-16 text-neutral-300" />,
    postFollowersEngRate: (
      <Icon name="Bookmark" className="text-16 text-neutral-300" />
    ),
    postReachEngRate: (
      <Icon name="PromoteActive" className="text-16 text-neutral-300" />
    ),
    replies: <Icon name="Chat" className="text-16 text-neutral-300" />,
  };
  return iconMap[metricKey] || <Icon name="Eye" />;
};

export const getMetricLabel = (metricKey: string) => {
  const labelMap: Record<string, string> = {
    viewsCount: 'Views',
    postFollowersEngRate: 'Follower Engagement Rate',
    postReachEngRate: 'Reach Engagement Rate',
    followersEngagementRate: 'Followers Engagement Rate',
    impressions: 'Impressions',
    engagements: 'Engagements',
    likes: 'Likes',
    comments: 'Comments',
    saved: 'Saves',
    shares: 'Shares',
    reach: 'Reach',
    views: 'Views',
    totalViews: 'Total Views',
    avgViewDuration: 'Avg View Duration',
    clickThroughRate: 'Click Through Rate',
    completionRate: 'Completion Rate',
    watchTime: 'Watch Time',
    subscribers: 'Subscribers',
    replies: 'Replies',
  };

  return (
    labelMap[metricKey] ||
    metricKey.charAt(0).toUpperCase() + metricKey.slice(1)
  );
};
export const getPlatformMetrics = (
  contentData: IApiSearchContent | undefined,
) => {
  if (!contentData) {
    return { engagementMetrics: [], otherMetrics: [] };
  }

  const engagementMetrics: MetricItem[] = [];
  const otherMetrics: MetricItem[] = [];

  // Extract common metrics from contentData
  const dataWithMetrics = contentData as any;

  // Check for metrics in various possible locations
  const metricsSource = dataWithMetrics.metrics || dataWithMetrics;

  // Engagement metrics (first column)
  const engagementFields = ['likes', 'comments', 'saved', 'shares'];

  // Other metrics (second column)
  const otherFields = [
    'viewsCount',
    'reach',
    'postFollowersEngRate',
    'postReachEngRate',
    'replies',
  ];

  engagementFields.forEach((field) => {
    const value = metricsSource[field];
    if (value !== null && value !== undefined) {
      engagementMetrics.push({
        icon: getMetricIcon(field),
        label: getMetricLabel(field),
        value:
          typeof value === 'number' ? value.toLocaleString() : String(value),
      });
    }
  });

  otherFields.forEach((field) => {
    const value = metricsSource[field];
    if (value !== null && value !== undefined) {
      otherMetrics.push({
        icon: getMetricIcon(field),
        label: getMetricLabel(field),
        value:
          typeof value === 'number'
            ? field === 'postFollowersEngRate' || field === 'postReachEngRate'
              ? (value * 100).toLocaleString() + '%'
              : value.toLocaleString()
            : String(value),
      });
    }
  });

  return { engagementMetrics, otherMetrics };
};
